module.exports = __webpack_public_path__ + "static/media/tick.165de949.svg";